import { IStoreState } from '@/store';
import useTypedSelector from './use-typed-selector';

/* eslint-disable max-len */
const useSelectorUser = <K extends keyof IStoreState['user']>(key: K) => useTypedSelector((store) => store.user[key]) as IStoreState['user'][K];

export default useSelectorUser;
